import { render, staticRenderFns } from "./WindowStats.vue?vue&type=template&id=262ad6c4&"
import script from "./WindowStats.vue?vue&type=script&lang=js&"
export * from "./WindowStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports